<template>
    <div v-if="!isLoading">
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 100px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.settingAdvanced.tabMail') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <b-tabs
                v-model="currentTab"
                content-class="mt-3"
                active-nav-item-class="font-weight-bold text-uppercase text-success acitve-tab-custom-form"
                @input="onHandleCickTab"
            >
                <b-tab v-for="(tab, index) in TAB_EMAIL" :key="index" class="border-0">
                    <template v-slot:title>
                        <span class="">{{ tab.name }}</span>
                    </template>
                    <b-card-text>
                        <AlertAdmin
                            v-if="tab.id === 1"
                            ref="alertAdmin"
                            :formData.sync="formDataAdmin"
                            :configData="configDataAdmin"
                            :listBlock="listBlockOfForm"
                            :listMail="listBlockMail"
                            :listOriginBlock="LIST_OPTION_SUBJECT_DEFAULT"
                            :listEmailReplyAddress="listEmailReplyAddress"
                            :listEmailFromAddress="listEmailFromAddress"
                        />
                        <AlertAnswer
                            v-else-if="tab.id === 2"
                            ref="alertAnswer"
                            :formData.sync="formDataAnswer"
                            :configData="configDataAswer"
                            :listBlock="listBlockOfForm"
                            :listMail="listBlockMail"
                            :listEmailFromAddress="listEmailFromAddress"
                            :listOriginBlock="LIST_OPTION_SUBJECT_DEFAULT"
                        />
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </div>
        <div class="col-sm-12 text-center mb-5">
            <button type="button" class="btn btn-success px-5" @click="onHandleSaveEmail" :disabled="!checkPermission('form.edit')">
                {{ $t('managerForm.settingPage.saveErrorMsg') }}
            </button>
        </div>
    </div>
    <div v-else class="d-flex justify-content-center">
        <LoadingIcon />
    </div>
</template>

<script>
import AlertAdmin from './components/alert-admin/main.vue';
import AlertAnswer from './components/alert-user-answer/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { initFieldAdmin, initFieldAnswer, OPTION_SUBJECT_DEFAULT, OPTION_REPLY_ADDRESS, OPTION_MAIL_I } from './constants';
import { answerOnHandleMapEachOption, adminOnHandleMapEachOption, onHandleValidateTabs, onHandleShowMessageValidateTabs } from './handlers';
import { TAB_EMAIL, OPTION_SEND_EMAIL, nameTab } from './constants';
import { managerFormMethods } from '@/state/helpers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { OPTION_INPUT_FORMAT } from '@/views/pages/phase2/manager-form/components/setting-block-form/constants';
import { showMessage } from '@/utils/messages';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';
import { STATUS_MAIL } from '@/views/pages/phase2/manager-form/email/constants.js';
import { checkPermission } from '@/utils/handlers';

export default {
    name: 'SettingEmail',
    components: { AlertAdmin, AlertAnswer, LoadingIcon },
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            TAB_EMAIL,
            nameTab,
            LIST_OPTION_SUBJECT_DEFAULT: OPTION_SUBJECT_DEFAULT(),
            OPTION_SEND_EMAIL: OPTION_SEND_EMAIL(),
            formDataAdmin: initFieldAdmin(),
            configDataAdmin: initFieldAdmin().configEachField(),
            formDataAnswer: initFieldAnswer(),
            configDataAswer: initFieldAnswer().configEachField(),
            addressReplyOptions: OPTION_REPLY_ADDRESS,
            currentTab: 0,
            listBlockOfForm: [],
            listBlockMail: [],
            listBlockOrigin: [],
            isLoading: true,
            dataAdmin: null,
            dataClient: null,
            listEmailReplyAddress: [],
            listEmailFromAddress: []
        };
    },
    methods: {
        checkPermission,
        ...managerFormMethods,
        async onGetListAllEmailReply() {
            try {
                let dataRes = await this.getListAllEmailReply();
                this.listEmailReplyAddress = dataRes;
            } catch (error) {
                console.log('error', error);
            }
        },
        returnStatusMailLabel(status) {
            return STATUS_MAIL.find((item) => item.value === status)?.label;
        },
        async onGetListAllEmailFrom() {
            try {
                let dataRes = await this.getListAllEmailFrom();
                this.listEmailFromAddress = dataRes?.map((item) => ({
                    ...item,
                    label_mail: `${item.email_address} - ${item.title} - 認証ステータス: ${this.returnStatusMailLabel(item.status_domain)}`
                }));
            } catch (error) {
                console.log('error', error);
            }
        },

        onHandleCickTab() {
            if (TAB_EMAIL[this.currentTab].name === nameTab.admin) {
                this.formDataAdmin = {
                    ...initFieldAdmin(this.dataAdmin),
                    block_id: this.listBlockOfForm.find((item) => item.id === this.dataAdmin?.block_id) ?? null,
                    choice_reply_address:
                        this.listBlockMail.find((item) => item.id === this.dataAdmin?.choice_reply_address[0]) ?? this.addressReplyOptions[0],
                    from_address: this.listEmailFromAddress.find((item) => item.email_address === this.dataAdmin?.from_address) ?? '',
                    email_reply_address: this.listEmailReplyAddress.find((item) => item.email_address === this.dataAdmin?.email_reply_address) ?? '',
                    email_settings_for_each_option: adminOnHandleMapEachOption(
                        this.dataAdmin?.email_settings_for_each_option,
                        this.listBlockOfForm.find((item) => item.id === this.dataAdmin?.block_id) ?? null
                    )
                };
                this.configdataAdmin = initFieldAdmin(this.dataAdmin).configEachField(this.dataAdmin);
            } else if (TAB_EMAIL[this.currentTab].name === nameTab.answer) {
                this.formDataAnswer = {
                    ...initFieldAnswer(this.dataClient),
                    from_address: this.listEmailFromAddress.find((item) => item.email_address === this.dataClient?.from_address) ?? '',
                    block_id: this.listBlockOfForm.find((item) => item.id === this.dataClient?.block_id) ?? null,
                    to_address:
                        this.dataClient?.to_address
                            ?.map((item) => this.listBlockMail.find((block) => block.id === item || block?.label === item))
                            ?.filter((item) => item?.id !== undefined) ?? [],
                    email_settings_for_each_option: answerOnHandleMapEachOption(
                        this.dataClient?.email_settings_for_each_option,
                        this.listBlockOfForm.find((item) => item.id === this.dataClient?.block_id) ?? null,
                        this.listBlockMail,
                        this.listEmailFromAddress
                    )
                };
                this.configDataAswer = initFieldAnswer(this.dataClient).configEachField(this.dataClient);
            }
        },

        async onHandleSaveEmail() {
            let checkAllAdmin = true;
            let checkAllClient = true;
            let checkAllMailAdmin = true;
            let checkAllMailClient = true;
            let checkConditionBlockAdmin = true;
            let checkConditionBlockAdminMail = true;
            let checkConditionBlockAnswer = true;
            let checkConditionBlockAnswerMail = true;
            let checkNotSendAllAdminMail = true;
            let checkNotSendAllAnswerMail = true;
            let payload = {
                form_id: this.$route.query.id ? Number(this.$route.query.id) : null,
                admin_mail: {
                    setting_type: 1
                },
                client_mail: {
                    setting_type: 2
                }
            };

            let resultValidate = onHandleValidateTabs(
                this.configDataAdmin,
                this.formDataAdmin,
                this.configDataAswer,
                this.formDataAnswer,
                this.$refs,
                this.$bvToast,
                payload,
                checkAllAdmin,
                checkAllClient,
                checkConditionBlockAdmin,
                checkConditionBlockAnswer,
                checkAllMailAdmin,
                checkAllMailClient,
                checkConditionBlockAdminMail,
                checkConditionBlockAnswerMail,
                checkNotSendAllAdminMail,
                checkNotSendAllAnswerMail,
                this.currentTab
            );
            payload = resultValidate.payload;
            checkAllAdmin = resultValidate.checkAllAdmin;
            checkAllClient = resultValidate.checkAllClient;
            checkConditionBlockAdmin = resultValidate.checkConditionBlockAdmin;
            checkConditionBlockAnswer = resultValidate.checkConditionBlockAnswer;
            checkAllMailAdmin = resultValidate.checkAllMailAdmin;
            checkAllMailClient = resultValidate.checkAllMailClient;
            checkConditionBlockAdminMail = resultValidate.checkConditionBlockAdminMail;
            checkConditionBlockAnswerMail = resultValidate.checkConditionBlockAnswerMail;
            checkNotSendAllAdminMail = resultValidate.checkNotSendAllAdminMail;
            checkNotSendAllAnswerMail = resultValidate.checkNotSendAllAnswerMail;

            let isShowMessage = onHandleShowMessageValidateTabs(
                this.$bvToast,
                {
                    checkAllAdmin,
                    checkAllMailAdmin,
                    checkConditionBlockAdmin,
                    checkConditionBlockAdminMail,
                    checkNotSendAllAdminMail
                },
                { checkAllClient, checkAllMailClient, checkConditionBlockAnswer, checkConditionBlockAnswerMail, checkNotSendAllAnswerMail }
            );
            if (isShowMessage) return;
            try {
                const dataRes = await this.formSettingEmail(payload);
                if (dataRes.code !== 200) {
                    if (dataRes.message.includes('exists')) {
                        showMessage(dataRes.code, this.$bvToast, '送信者メールアドレスが登録されていません。ご注意ください。');
                    } else showMessage(dataRes.code, this.$bvToast, this.$t(dataRes.message));
                    return;
                }
                showMessage(dataRes.code, this.$bvToast, 'メールが設定されました。');
                this.onHandleGetDetailSettingMail();
            } catch (error) {
                console.log('error', error);
            }
        },

        async onGetListBlockOfForm() {
            this.isLoading = true;
            try {
                if (this.detailForm.type === ID_PAGE_TYPE.I) {
                    this.listBlockMail = [OPTION_MAIL_I];
                }
                const dataRes = await this.getListBlockOriginalOfForm(this.$route.query.id);
                let sortData = dataRes?.sort((a, b) => a.order_index - b.order_index);
                let mailBlockTypeForm = [];
                sortData.forEach((item) => {
                    item.options = item.list_options;
                });
                this.listBlockOfForm = sortData.filter((item) =>
                    [
                        ALL_BLOCK_TYPE.BLOCK_RADIO,
                        ALL_BLOCK_TYPE.BLOCK_SELECT,
                        ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
                        ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE
                    ].includes(item.block_type)
                );
                const formatBlockList = sortData
                    .filter((item) => item.block_type === ALL_BLOCK_TYPE.BLOCK_INPUT && OPTION_INPUT_FORMAT[1].id === item.extension.input_format)
                    .map((item) => {
                        item.label = `フォーム:${item.block_name}`;
                        return item;
                    });
                if (this.detailForm.type === ID_PAGE_TYPE.I) {
                    mailBlockTypeForm = [OPTION_MAIL_I, ...formatBlockList];
                } else {
                    mailBlockTypeForm = formatBlockList;
                }
                this.listBlockMail = mailBlockTypeForm;
                this.listBlockOrigin = sortData.map((item) => {
                    item.label = `フォーム:${item.block_name}`;
                    return item;
                });
                this.LIST_OPTION_SUBJECT_DEFAULT.splice(1, 0, ...this.listBlockOrigin);
                if (this.listBlockMail.length === 0) {
                    this.TAB_EMAIL = [this.TAB_EMAIL[0]];
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async onHandleGetDetailSettingMail() {
            try {
                const dataGet = await this.getDetailSettingEmail(this.$route.query.id);
                this.dataAdmin = dataGet.data.admin_mail;
                this.dataClient = dataGet.data.client_mail;
                this.formDataAdmin = {
                    ...initFieldAdmin(this.dataAdmin),
                    from_address: this.listEmailFromAddress.find((item) => item.email_address === this.dataAdmin?.from_address) ?? '',
                    block_id: this.listBlockOfForm.find((item) => item.id === this.dataAdmin?.block_id) ?? null,
                    choice_reply_address:
                        this.listBlockMail.find((item) => item.id === this.dataAdmin?.choice_reply_address[0]) ?? this.addressReplyOptions[0],
                    email_reply_address: this.listEmailReplyAddress.find((item) => item.email_address === this.dataAdmin?.email_reply_address) ?? '',
                    email_settings_for_each_option: adminOnHandleMapEachOption(
                        this.dataAdmin?.email_settings_for_each_option,
                        this.listBlockOfForm.find((item) => item.id === this.dataAdmin?.block_id) ?? null
                    )
                };
                this.formDataAnswer = {
                    ...initFieldAnswer(this.dataClient),
                    from_address: this.listEmailFromAddress.find((item) => item.email_address === this.dataClient?.from_address) ?? '',
                    block_id: this.listBlockOfForm.find((item) => item.id === this.dataClient?.block_id) ?? null,
                    to_address:
                        this.dataClient?.to_address
                            ?.map((item) => this.listBlockMail.find((block) => block.id === item))
                            .filter((item) => item?.id !== undefined) ?? [],
                    email_settings_for_each_option: answerOnHandleMapEachOption(
                        this.dataClient?.email_settings_for_each_option,
                        this.listBlockOfForm.find((item) => item.id === this.dataClient?.block_id) ?? null,
                        this.listBlockMail,
                        this.listEmailFromAddress
                    )
                };
                this.configdataAdmin = initFieldAdmin(this.dataAdmin).configEachField(this.dataAdmin);
                this.configDataAswer = initFieldAnswer(this.dataClient).configEachField(this.dataClient);
            } catch (error) {
                console.log('error', error);
            }
        }
    },

    async mounted() {
        await this.onGetListAllEmailFrom();
        await this.onGetListAllEmailReply();
        await this.onGetListBlockOfForm();
        this.onHandleGetDetailSettingMail();
    }
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.acitve-tab-custom-form {
    border-color: #16cd8e #16cd8e #fff !important;
}
</style>
